import axios from "axios";
import * as d3 from "d3";
import {numberFormat} from '../functions'
import * as d3Sankey from "../../library/sankey";

export default function (chart, divId, vizName,resData, filterParam) {
    // format variables
    const
        //     formatNumber = d3.format(".1f"), // zero decimal places
        //    format = function (d) {
        //     return formatNumber(d);
        // },

        fontScale = d3.scaleLinear()
            .range([14, 22]);


    //transition times
    const transition = 50;
    console.log(transition)


    // var url1 = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    var url2 = '/api/fetchDataWithParam/' + chart.data.vizSpecific4 + '/Any'
    console.log("Chart vizName called:", vizName, filterParam)

    axios.all([

        // axios.post(url1, filterParam),
        axios.post(url2, {}),

    ]).then(axios.spread(function ( r1) {

        //Assigning to the variables from axios output
        var csv = resData;
        var deficit = r1.data.rowsData;

        var thisYear = csv[0].dim3_name


        console.log("main", csv)

        console.log("deficit", deficit)


        var thisYearCsv = csv.filter(function (d) {
            if (d['dim3_name'] == thisYear) {
                return d
            }
        });

        var thisYearDeficit = deficit.filter(function (d) {
            if (d['dim3_name'] == thisYear) {
                console.log(d)
                return d
            }
        });
        console.log(thisYearDeficit)


        console.log("deficit", deficit)


        console.log("thisYearCsv", thisYearCsv)


        //create an array to push all sources and targets, before making them unique
        //because starting nodes are not targets and end nodes are not sources
        var arr = [];
        thisYearCsv.forEach(function (d) {
            arr.push(d.dim1_name);
            arr.push(d.dim2_name);
        }); //console.log(arr.filter(onlyUnique))

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }


        // create nodes array
        var nodes = arr.filter(onlyUnique).map(function (d, i) {
            return {
                node: i,
                name: d
            }
        });

        console.log("nodes:", nodes)
        // create links array
        var links = thisYearCsv.map(function (thisYearCsv_row) {
            return {
                source: getNode("dim1_name"),
                target: getNode("dim2_name"),
                value: +thisYearCsv_row.metric1,
                type: thisYearCsv_row.dim4_name //to alow for proper keying
            }


            function getNode(type) {
                return nodes.filter(function (node_object) {
                    return node_object.name == thisYearCsv_row[type];
                })[0].node;
            }
        });


        // let lineData = csv
        // lineData.forEach(function (d) {
        //     //   d.year = new Date(d.year);
        //     d.metric1 = +d.metric1;
        // });
        // console.log(lineData)

        var sankeySvg = d3.select(divId).select("svg").remove();

        // set the dimensions and margins of the graph
        let sankeyMargin = {top: 30, right: 10, bottom: 10, left: 10},
            sankeyWidth = divId.offsetWidth - sankeyMargin.left - sankeyMargin.right,
            sankeyHeight = 415 - sankeyMargin.top - sankeyMargin.bottom;

        // append the svg object to the body of the page
        sankeySvg = d3.select(divId).append("svg")
            .attr("width", sankeyWidth + sankeyMargin.left + sankeyMargin.right)
            .attr("height", sankeyHeight + sankeyMargin.top + sankeyMargin.bottom)
            .attr('class', 'sankeyCanvas')
            // .style('background', '#e8e8e8')
            .append("g")
            .attr("transform",
                "translate(" + sankeyMargin.left + "," + sankeyMargin.top + ")");

        // Set the sankey diagram properties
        let sankey = d3Sankey
            .d3sankey()
            .nodeWidth(60)
            .nodePadding(20)
            .size([sankeyWidth, sankeyHeight]);

        const path = sankey.link();

        sankey.nodes(nodes)
            .links(links)
            .layout(1000);


        fontScale.domain(d3.extent(nodes, function (d) {
            return d.value
        }));

        console.log("nodes", nodes)
        console.log("links", links)
        // add in the links
        let link = sankeySvg.append("g").selectAll(".link")
            .data(links, function (d) {
                return d.id;
            })
            .enter().append("path")
            .attr("class", "sank-link")
            .attr("d", path)
            .style('stroke', function (d) {
                return d.type == chart.x2AxisDisplayName ? '#006d2c' :
                    d.type == chart.y1AxisDisplayName ? '#de2d26' : d.type == chart.y2AxisDisplayName ? '#08519c' : 'grey'
            })
            .style("stroke-width", function (d) {
                return Math.max(1, d.dy);
            })


        console.log(link)

        // add in the nodes
        let node = sankeySvg.append("g").selectAll(".node")
            .data(nodes)
            .enter().append("g")
            .attr("class", "sank-node")
            .attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")"
            });

        node.append("title")
            .text(function (d) {
                var titleText = d.name + " - " + numberFormat(d.value) + " total" + "\n" + "\n";
                var sourcesText = "";
                d.targetLinks.forEach(function (dstLnk) {
                    sourcesText += "from " + dstLnk.source.name + " - " + numberFormat(dstLnk.value) + "\n";
                });
                return titleText + sourcesText;
            });

        // add the rectangles for the nodes
        node.append("rect")
            .attr("height", function (d) {
                return d.dy < 0 ? .1 : d.dy;
            })
            .attr("width", sankey.nodeWidth())
            // .attr('key', function (d) {
            //     return d.name.split(' ').join('_');
            // })
            .attr('value', function (d) {
                return d.value;
            })
            .attr('class', 'nodeRect')
            .style("fill", 'lightgrey')
            .style("opacity", 0.5)
            .style("stroke", 'black')
        //  .on('mouseover', highlight);

        // title for the nodes
        node.append("text")
            .attr("x", -6)
            .attr("y", function (d) {
                return d.dy / 2;
            })
            .attr("dy", ".35em")
            .attr("text-anchor", "end")
            .attr("transform", null)
            .style("font-size", function (d) {
                return Math.floor(fontScale(d.value)) + "px";
            })
            .text(function (d) {
                return d.name;
            })
            .filter(function (d) {
                return d.x < sankeyWidth / 2;
            })
            .attr("x", 6 + sankey.nodeWidth())
            .attr("text-anchor", "start")
            .attr('class', 'nodeLabel');

        // (in M) for the nodes
        node.append("text")
            .attr("text-anchor", "middle")
            .attr("x", 30)
            .attr("y", function (d) {
                return d.dy / 2;
            })
            .style("font-size", 15)
            .attr("dy", ".35em")
            // .filter(function (d) {
            //     return d.value > 1
            // })
            // .filter(function (d) {
            //     return d.node != 20
            // }) //do spending seperately to correctly show surplus
            .text(function (d) {
                return numberFormat(d.value) + ' ' + chart.x1AxisDisplayName
            })
            .attr('class', 'nodePercent');


        //highlight deficit
        console.log(thisYearDeficit);
        let barHeight = d3.select('rect[key=chart.y1AxisDisplayName]').attr('height');
        let barVal = d3.select('rect[key=chart.y1AxisDisplayName]').attr('value');
        let deficitVal = thisYearDeficit[0].deficit;

        //get deficit bar size with ratio of spending value to bar height
        let deficitBarRatio = (barHeight * deficitVal) / barVal;
        //console.log(deficitBarRatio)

        let deficitBar = d3.select('rect[key=chart.y1AxisDisplayName]')
            .select(function () {
                return this.parentNode
            })
            .append('rect')
            .attr("width", sankey.nodeWidth())
            .attr("y", function (d) {
                if (deficitBarRatio < 0) {
                    return d.dy + deficitBarRatio;
                } else {
                    return d.dy - deficitBarRatio
                }
            })
            .style('fill', function () {
                if (deficitBarRatio < 0) {
                    return '#6baed6'
                } else {
                    return '#fb6a4a'
                }
            })
            .style('opacity', 0.8)
            .attr('class', 'deficit');

        console.log(deficitBar)

        sankeySvg.append('text')
            .attr("text-anchor", "middle")
            .attr("x", sankeyWidth / 2)
            .attr("y", sankeyHeight * .92)
            .style("font-size", 28)
            .style("font-weight", 'bold')
            .attr('class', 'deficitLabel')
            .style('fill', function () {
                if (deficitBarRatio < 0) {
                    return '#6baed6'
                } else {
                    return '#fb6a4a'
                }
            });


        // var y1legend = sankeySvg
        //     .selectAll('.legend')
        //     .data([chart.x2AxisDisplayName,chart.y1AxisDisplayName,chart.y2AxisDisplayName])
        //     .enter()
        //     .append('g')
        //     .attr('class', 'legend')
        //     .attr('transform', function(d, i) {                     // NEW
        //         //  var height = 0;          // NEW
        //         var horz = 180*i;                       // NEW
        //         var vert = 6;                        // NEW
        //         return 'translate(' + horz + ',' + vert + ')';        // NEW
        //     });
        //
        // y1legend.append('rect')
        //     .attr('x',(chart.width/7))
        //     .attr('y', chart.height+ 2*chart.margin.bottom)
        //     .attr('width', 20)
        //     .attr('height', 20)
        //     .style('fill',function (d) {
        //     return d.type == chart.x2AxisDisplayName ? '#006d2c' :
        //         d.type == chart.y1AxisDisplayName ? '#de2d26' : d.type == chart.y2AxisDisplayName ? '#08519c' : 'grey'
        // })
        //
        // y1legend.append('text')
        //     .attr('x',(chart.width/7) + 20)
        //     .attr('y', chart.height+ 2*chart.margin.bottom)
        //     .attr('dy', '1em')
        //     .style('font-size', '14px')
        //     //  .style('text-anchor', 'end')
        //     .text(function (d) { d
        //
        //     })
    }))
}
